import { defineMessages } from 'react-intl';

export default defineMessages({
  dashboardTitle: {
    id: 'app.dashboard.title',
    defaultMessage: 'Your dashboard',
  },
  dashboardAccountManagerTitle: {
    id: 'app.dashboard.accountManager.title',
    defaultMessage: 'Need to speak to us?',
  },
  dashboardProductInLibraryText: {
    id: 'app.dashboard.productsInLibrary.singular.text',
    defaultMessage: 'Product in your library',
  },
  dashboardProductsInLibraryText: {
    id: 'app.dashboard.productsInLibrary.plural.text',
    defaultMessage: 'Products in your library',
  },
  dashboardStartOrderingButtonText: {
    id: 'app.dashboard.productsInLibrary.startOrdering.buttonText',
    defaultMessage: ' Start ordering',
  },
  orderHistoryTitle: {
    id: 'app.dashboard.orderHistory.title',
    defaultMessage: 'Your recent orders',
  },
});
